import React from "react";

import PrivacyPolicyContent from "./PrivacyPolicyContent";
import MainLayout from "./admin/MainLayout";

function PrivacyPolicyPage() {
  return (

    <MainLayout>
      <div >
        <PrivacyPolicyContent />
      </div>
    </MainLayout>



  )
}

export default PrivacyPolicyPage;

